const scheduledReports = {
  en: {
    scheduledReports: {
      prefsSaved: "Preferences saved",
      prefsFailed: "Failed to save preferences",
      previewFailed: "Failed to load preview",
      reportSent: "{{type}} report sent",
      sentTo: "Sent to {{count}} administrators",
      sendFailed: "Failed to send report",
      reportSentToYou: "{{type}} report sent to your email",
      daily: "Daily",
      weekly: "Weekly",
      dailyBtn: "Daily",
      weeklyBtn: "Weekly",
      reportPrefs: "Report Preferences",
      reportPrefsDesc: "Configure your automated report settings",
      enableEmail: "Enable Email Reports",
      enableEmailDesc: "Receive automated analytics reports",
      frequency: "Frequency",
      freqNone: "None",
      freqDaily: "Daily Only",
      freqWeekly: "Weekly Only",
      freqBoth: "Daily + Weekly",
      weeklyDay: "Weekly Day",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
      },
      deliveryTime: "Delivery Time",
      morning: "Morning (6 AM)",
      afternoon: "Afternoon (12 PM)",
      evening: "Evening (6 PM)",
      includeCharts: "Include Charts",
      includeChartsDesc: "Embed visual charts in emails",
      sendReports: "Send Reports",
      sendReportsDesc: "Preview and manually trigger report emails",
      dailySummary: "Daily Summary",
      withCharts: "With Charts",
      dailyDesc: "Previous day's submissions, approvals, alerts, and trend charts",
      preview: "Preview",
      dailyPreviewTitle: "Daily Report Preview (with Charts)",
      dailyPreviewDesc: "This is how the daily email report will look",
      clickPreview: "Click Preview to load report",
      sendToMe: "Send to Me",
      sendAll: "Send All",
      weeklyDigest: "Weekly Digest",
      weeklyDesc: "Week's trends, regional coverage charts, top performers",
      weeklyPreviewTitle: "Weekly Report Preview (with Charts)",
      weeklyPreviewDesc: "This is how the weekly email digest will look",
      aboutDelivery: "About Email Delivery",
      aboutDeliveryText: "Reports include embedded charts (pie charts, bar charts, trend lines). \"Send All\" sends to all admins/supervisors with reports enabled. \"Send to Me\" sends only to your email."
    }
  },
  fr: {
    scheduledReports: {
      prefsSaved: "Préférences enregistrées",
      prefsFailed: "Échec de l'enregistrement des préférences",
      previewFailed: "Échec du chargement de l'aperçu",
      reportSent: "Rapport {{type}} envoyé",
      sentTo: "Envoyé à {{count}} administrateur(s)",
      sendFailed: "Échec de l'envoi du rapport",
      reportSentToYou: "Rapport {{type}} envoyé à votre adresse e-mail",
      daily: "quotidien",
      weekly: "hebdomadaire",
      dailyBtn: "Quotidien",
      weeklyBtn: "Hebdomadaire",
      reportPrefs: "Préférences de rapports",
      reportPrefsDesc: "Configurez vos paramètres de rapports automatisés",
      enableEmail: "Activer les rapports par e-mail",
      enableEmailDesc: "Recevez des rapports d'analyse automatisés",
      frequency: "Fréquence",
      freqNone: "Aucune",
      freqDaily: "Quotidien uniquement",
      freqWeekly: "Hebdomadaire uniquement",
      freqBoth: "Quotidien + hebdomadaire",
      weeklyDay: "Jour hebdomadaire",
      days: {
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche"
      },
      deliveryTime: "Heure d'envoi",
      morning: "Matin (6 h)",
      afternoon: "Après-midi (12 h)",
      evening: "Soir (18 h)",
      includeCharts: "Inclure les graphiques",
      includeChartsDesc: "Intégrer des graphiques visuels dans les e-mails",
      sendReports: "Envoyer les rapports",
      sendReportsDesc: "Prévisualisez et déclenchez manuellement l'envoi des rapports par e-mail",
      dailySummary: "Résumé quotidien",
      withCharts: "Avec graphiques",
      dailyDesc: "Soumissions, approbations, alertes et graphiques de tendance de la veille",
      preview: "Aperçu",
      dailyPreviewTitle: "Aperçu du rapport quotidien (avec graphiques)",
      dailyPreviewDesc: "Voici à quoi ressemblera le rapport quotidien envoyé par e-mail",
      clickPreview: "Cliquez sur Aperçu pour charger le rapport",
      sendToMe: "M'envoyer",
      sendAll: "Envoyer à tous",
      weeklyDigest: "Synthèse hebdomadaire",
      weeklyDesc: "Tendances de la semaine, graphiques de couverture régionale, meilleurs résultats",
      weeklyPreviewTitle: "Aperçu du rapport hebdomadaire (avec graphiques)",
      weeklyPreviewDesc: "Voici à quoi ressemblera la synthèse hebdomadaire envoyée par e-mail",
      aboutDelivery: "À propos de l'envoi par e-mail",
      aboutDeliveryText: "Les rapports incluent des graphiques intégrés (secteurs, barres, courbes de tendance). « Envoyer à tous » envoie le rapport à tous les administrateurs/superviseurs ayant activé les rapports. « M'envoyer » l'envoie uniquement à votre adresse e-mail."
    }
  }
};

export default scheduledReports;
